import { useEffect } from "react";
import useSyncWithQueryParameters from "views/hooks/useSyncWithQueryParameters";
import bindSearchParamsFromQuery from "views/hooks/BindSearchParamsFromQuery";
import useViewsDispatch from "views/stores/useViewsDispatch";
import { selectView } from "views/logic/slices/viewSelectors";
import { selectSearchExecutionState } from "views/logic/slices/searchExecutionSelectors";
import useLocation from "routing/useLocation";
import useQuery from "routing/useQuery";
import { updateView, executeActiveQuery } from "views/logic/slices/viewSlice";
import { updateGlobalOverride } from "views/logic/slices/searchExecutionSlice";
import GlobalOverride from "views/logic/search/GlobalOverride";
const bindSearchParamsFromQueryThunk = (query) => async (dispatch, getState) => {
  var _a;
  const view = selectView(getState());
  const executionState = selectSearchExecutionState(getState());
  const result = await bindSearchParamsFromQuery({ view, query, retry: () => Promise.resolve(), executionState });
  if (!result) {
    return Promise.resolve();
  }
  const [newView, newExecutionState] = result;
  const viewChanged = newView !== view;
  const executionStateChanged = newExecutionState !== executionState;
  if (!viewChanged && !executionStateChanged) {
    return Promise.resolve();
  }
  if (executionStateChanged) {
    await dispatch(updateGlobalOverride((_a = newExecutionState.globalOverride) != null ? _a : GlobalOverride.empty()));
  }
  if (viewChanged) {
    await dispatch(updateView(newView));
  }
  return dispatch(executeActiveQuery());
};
const useBindSearchParamsFromQuery = (query) => {
  const dispatch = useViewsDispatch();
  useEffect(() => {
    dispatch(bindSearchParamsFromQueryThunk(query));
  }, [query]);
};
const SynchronizeUrl = () => {
  const { pathname, search } = useLocation();
  const query = useQuery();
  useBindSearchParamsFromQuery(query);
  useSyncWithQueryParameters(`${pathname}${search}`);
  return null;
};
export default SynchronizeUrl;
